<template>
    <div class="left_panel">
        <div
            class="panel_head_wrap d-flex align-items-end justify-content-between"
        >
            <div class="panel_heading">
                <h2>My Designs</h2>
                <div class="subhead">Manage your saved designs</div>
            </div>
        </div>

        <div class="my-designs-wrap">
            <div
                v-if="!savedDesigns || savedDesigns.length == 0"
                class="no-results"
            >
                <span>No designs found.</span>
            </div>
            <div
                v-else
                class="designs-grid"
            >
                <DesignCard
                    v-for="(design, index) in paginatedDesigns"
                    :key="design.id || index"
                    :design="design"
                    @delete="handleDeleteDesign"
                />
            </div>
            <b-pagination
                v-show="total_designs > 0 && item_length > itemsPerPage"
                v-model="currentPage"
                :total-rows="item_length"
                :per-page="itemsPerPage"
                class="imprint_pagination"
                @input="handlePageChange"
            ></b-pagination>
        </div>
        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
import DesignCard from "@/components/frontend/account/DesignCard.vue";

export default {
    name: "MyDesign",
    components: {
        DesignCard
    },
    data() {
        return {
            savedDesigns: [],
            isLoader: false,
            listConfig: {
                category_id: null,
                attribute_set_id: null
            },
            item_length: 0,
            currentPage: 1,
            itemsPerPage: 10,
            total_designs: 0
        };
    },
    computed: {
        pages() {
            if (this.item_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(Math.ceil(this.item_length / this.itemsPerPage)).keys()
            ].map((e) => e + 1);
        },
        paginatedDesigns() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.savedDesigns.slice(start, end);
        }
    },
    watch: {
        currentPage() {
            // Scroll to top when page changes
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    },
    mounted() {
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
        var _this = this;
        _this.listConfig = {
            category_id: null,
            attribute_set_id: null
        };
        _this.getSavedDesigns();
    },
    methods: {
        getSavedDesigns(pagereset = false) {
            var _this = this;
            if (pagereset) {
                _this.currentPage = 1;
            }
            _this.isLoader = true;
            ApiService.setHeader();
            ApiService.query("/get-design-image-v2", {
                params: _this.listConfig
            })
                .then(({ data }) => {
                    _this.savedDesigns = data.design || [];
                    _this.total_designs = data.count || _this.savedDesigns.length || 0;
                    _this.item_length = data.count || _this.savedDesigns.length || 0;
                    _this.isLoader = false;
                })
                .catch(({ response }) => {
                    console.log(response);
                    _this.isLoader = false;
                    if (response && response.status == 401) {
                        _this.$router.push({ name: "/client/login" });
                    } else {
                        this.$toast.error("Failed to load designs", {
                            position: "top-right"
                        });
                    }
                });
        },
        handlePageChange(page) {
            this.currentPage = page;
        },
        handleDeleteDesign(designId) {
            if (confirm("Do you really want to delete this design?")) {
                this.isLoader = true;
                ApiService.post("/delete_canvasimages", {
                    ids: [designId.toString()]
                })
                    .then(() => {
                        this.$toast.success("Design deleted successfully", {
                            position: "top-right"
                        });
                        this.getSavedDesigns();
                    })
                    .catch(({ response }) => {
                        this.isLoader = false;
                        if (response && response.status == 401) {
                            this.$router.push({ name: "/client/login" });
                        } else {
                            this.$toast.error("Failed to delete design", {
                                position: "top-right"
                            });
                        }
                    });
            }
        },
        isValidHttpUrl(string) {
            if (!string) return false;
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;
            }
            return url.protocol === "http:" || url.protocol === "https:";
        }
    }
};
</script>

<style scoped>
.my-designs-wrap {
    margin-top: 24px;
}

.no-results {
    text-align: center;
    padding: 40px;
    color: #888888;
    font-size: 16px;
}

.designs-grid {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}
.designs-grid .design-card {
           flex: 0 0 49%;
        max-width: 49%;
}


@media (max-width: 1200px) {
    .designs-grid .design-card {
           flex: 0 0 48%;
        max-width: 48%;
}
}
@media (max-width: 768px) {
    .designs-grid .design-card {
           flex: 0 0 100%;
        max-width: 100%;
}
}
</style>